module.exports = __webpack_public_path__ + "fonts/SourceSansPro-BoldItalic.38845dae.ttf";